import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { authApi } from './api';
import { useAuthStore } from './store';

export function MfaPage() {
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [mfaToken] = useState<string | null>(sessionStorage.getItem('mfa-token'));

  useEffect(() => {
    if (!mfaToken) nav('/login');
  }, [mfaToken, nav]);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!mfaToken) return;
    setErr(null); setLoading(true);
    try {
      const res = await authApi.verify(mfaToken, code);
      if (res.step === 'COMPLETE' && res.accessToken && res.refreshToken && res.user) {
        useAuthStore.getState().setSession(res.accessToken, res.refreshToken, res.user);
        sessionStorage.removeItem('mfa-token');
        sessionStorage.removeItem('mfa-step');
        nav('/dashboard', { replace: true });
      }
    } catch (e: unknown) {
      const ax = e as { response?: { data?: { message?: string } } };
      setErr(ax.response?.data?.message || 'Código inválido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Paper sx={{ p: 4, width: 460, maxWidth: '94vw' }} component="form" onSubmit={submit}>
        <Typography variant="h5" gutterBottom>Verificación en dos pasos</Typography>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Ingresa el código de 6 dígitos de tu app autenticadora.
          </Typography>
          {err && <Alert severity="error">{err}</Alert>}
          <TextField
            label="Código"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            inputProps={{ inputMode: 'numeric', pattern: '\\d{6}' }}
            required fullWidth autoFocus
          />
          <Button type="submit" variant="contained" disabled={loading || code.length !== 6} size="large">
            Verificar
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
